import { render, staticRenderFns } from "./index.vue?vue&type=template&id=764a0da0&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('764a0da0')) {
      api.createRecord('764a0da0', component.options)
    } else {
      api.reload('764a0da0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=764a0da0&", function () {
      api.rerender('764a0da0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/news/index.vue"
export default component.exports